<template>
  <!-- 通用报表页面 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <span style="margin-right: 50px">当前报表：{{ tableName }}</span>
      <div class="glo_btnList_left">
        <!-- <el-button
            class="glo_btnItems glo_bgcMainColor"
            @click="addModifyBtns({}, 0)"
            >新建提货单</el-button
          > -->
        <el-button class="glo_btnItems" @click="isShowDialog_dc = true"
          >导出</el-button
        >
        <el-button class="glo_btnItems" @click="bgszFn()">表格设置</el-button>
        <!-- <el-dropdown class="topDropDown" @command="topCommandBtns">
            <el-button type="primary">
              更多操作
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="dtdc">导出</el-dropdown-item>
              <el-dropdown-item command="bgsz">表格设置</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown> -->
      </div>
      <queryBtns
        :isShowClear="true"
        :MoreConditions="MoreConditions"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <!-- 查询条件 --> 
    <!-- :formData="queryData" -->
    <queryCondition
      ref="queryForm"
      :More="isHaseMore"
      :formConfig="queryCondditionDatas"
    ></queryCondition>
    <!-- 表格 -->
    <div class="glo_Table">
      <el-table
        :height="tableHeigth"
        header-align="center"
        ref="mytable"
        @row-click="rowclick"
        :data="tableData"
        border
        stripe
        :highlight-current-row="true"
        show-summary
        :summary-method="getSummaries"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          fixed="left"
          align="center"
          label="序号"
          type="index"
          width="60"
        ></el-table-column>
        <el-table-column
          fixed="left"
          align="center"
          type="selection"
          width="60"
        ></el-table-column>
        <template v-for="(item, index) in myTableHeard">
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-if="item && item.isShow"
          >
            <template v-if="item.fieldIsGroup == 1">
              <template v-for="(itemc, indexc) in item.child">
                <el-table-column
                  :key="indexc"
                  :label="itemc.name"
                  :prop="itemc.field"
                  align="center"
                  :show-overflow-tooltip="true"
                  :min-width="itemc.width"
                  v-if="itemc && itemc.isShow"
                ></el-table-column>
              </template>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>

    <!-- 分页 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></paging>
    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    ></sorttable>

    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      :queryCondditionDatas="queryCondditionDatas"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
    </exportCompoent>
  </div>
</template>
  <script>
import tableList from "@/pages/FinancialManagement/ReportManager/js/tableList_bb.js";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import queryBtns from "@/components/queryBtns.vue";
import queryCondition from "@/components/queryCondition.vue";

import exportjs from "@/assets/js/Mixins/exportDT.js"; //导出的公共js

export default {
  mixins: [tableList, exportjs],
  inject: ["reload"],
  components: {
    sorttable,
    paging,
    queryBtns,
    queryCondition,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "", //导出时默认文件名
        apiName: "/v1/common/query/runPageReport", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "POST", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      pageGroupName: "", //  页面标识
      reportFiledsNumber: "", // 动态 条件、表头
      // command_list admin_waybill_posting_list
      tableName: "",
    };
  },

  created() {},
  mounted() {},
  activated() {
    let oldNumber = this.$route.query.oldNumber || "";
    let title = this.$route.query.title || "";
    if (oldNumber) {
      this.pageGroupName = oldNumber;
      this.reportFiledsNumber = oldNumber;
      console.log("oldNumber", oldNumber);
      this.initTable();
    }
    if (title) {
      this.tableName = title;
      this.dialogForm_dc.fileName = title;
    }
  },
  watch: {},
  methods: {
    // 新增、 修改 、查看
    addModifyBtns({ commandId }, type) {
      let query = {};
      switch (type) {
        case 1:
          query.commandId = commandId;
          break;
        case 2:
          query.isSee = "isSee";
          query.commandId = commandId;
          break;
      }
      this.$router.push({
        path: "/WaybillManage/NewPickupInstructionAddEdit",
        query,
      });
    },
    // 删除
    delBtns({ commandId }) {
      let ids = [];
      if (commandId) {
        ids = [commandId];
      } else {
        if (this.selectTableData.length < 1) {
          this.$message.error("请至少选择一条数据进行操作");
          return false;
        }
        this.selectTableData.forEach((item) => {
          ids.push(item.commandId);
        });
      }
      this.$confirm("确定要删除所选提货单吗? 请谨慎操作", "提示:")
        .then((res) => {
          this.$API.commanddelCommand({ commandIds: ids }).then((res) => {
            this.$message.success(res.data.message || "操作成功");
            this.getData();
          });
        })
        .catch((err) => {});
    },
  },
};
</script>
  <style scoped lang="less">
</style>
  